import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EarningsResponse } from '../models/earning-models/earnings-response';
import { AccountResponse } from '../models/account-models/account-response';
import { StatementCreditResponse } from '../models/statement-credit/statement-credit-response';
import { CurrentEarningsResponse } from '../models/statement-credit/current-earnings-response';
import { RedemptionResponse } from '../models/redemption-models/redemption-response';
import { GalleryVehicle } from '../models/vehicle-models/gallery-vehicle';
import { CardLookupRequest, CardLookupResponse } from '../models/card-models/card-lookup-model';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private readonly http: HttpClient) { }


  getAemPage(webpage: string): Observable<any> {
    return this.http.get('getAemPage/' + webpage);
  }

  getImage(image): Observable<any> {
    return this.http.get<any>(`getAemImage?image=${image}`);
  }

  getVerifyUserSessionByAccountId(accountId: string): Observable<any> {
    return this.http.get('updateSession/' + accountId);
  }
  getCustomer(accountId: string): Observable<AccountResponse> {
    return this.http.get<AccountResponse>('customer/' + accountId);
  }

  getVerifyUserSession(): Observable<any> {
    return this.http.get('verifySession');
  }

  getValidateEmail(customer: any): Observable<any> {
    return this.http.post('validate', customer);
  }

  getSsoUrl(email?: string, fallBack?: boolean): Observable<any> {
    let param;
    if (!email && !fallBack) {
      param = '';
    } else {
      param = {
        params: {
          email: email ? email : '',
          fallBack: fallBack ? fallBack : 'false'
        }
      };
    }

    return this.http.get('authenticate', param);
  }

  postLinkCard(linkCard: any): Observable<any> {
    return this.http.post('linkCard', linkCard);
  }

  getCreateAccount(): Observable<any> {
    return this.http.get('createAccount')
  }

  getDealersInfoByZipcode(brand, zipcode) {
    const endpoint = `dealer/${brand}/${zipcode}/25`;
    return this.http.get(endpoint);
  }

  getEarningsStatement(accountId: string): Observable<EarningsResponse> {
    const endpoint = `customer/earnings-statement/${accountId}`;
    return this.http.get<EarningsResponse>(endpoint);
  }

  getCurrentEarnings(
    accountId: string,
    redemptionType: string
  ): Observable<CurrentEarningsResponse> {
    const endpoint = `customer/current-earnings/${accountId}?source=CardSite&redemptionType=${redemptionType}`;
    return this.http.get<CurrentEarningsResponse>(endpoint);
  }

  getRegionalOffers(zipCode: string): Observable<any> {
    return this.http.get('offers/' + zipCode);
  }

  getStatementCredit(
    accountId: string,
    amount: string
  ): Observable<StatementCreditResponse> {
    const endpoint = `redeem/${accountId}?source=UITeam&redemptionType=ERT_CB&amount=${amount}`;
    return this.http.get<StatementCreditResponse>(endpoint);
  }
  getRedemptionHistory(accountId: string): Observable<RedemptionResponse> {
    return this.http.get<RedemptionResponse>('redemption/history/' + accountId);
  }
  getLogoutUrl(): Observable<any> {
    return this.http.get('logout');
  }

  getVehicleGallery(): Observable<Map<string, GalleryVehicle[]>> {
    const endpoint = 'vehicles/gallery';
    return this.http.get<Map<string, GalleryVehicle[]>>(endpoint);
  }

  lookupCard(request: CardLookupRequest): Observable<CardLookupResponse> {
    const endpoint = 'Lookup';
    return this.http.post<CardLookupResponse>(endpoint, request);
  }
}
